import React from 'react';

import './styles.scss';

export default function H1({
  children,
  className,
  ...props
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>) {
  return (
    <h1 className={`h1 ${className}`} {...props}>
      {children}
    </h1>
  );
}
